import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Staff';

const routes = [
    {
        matchRegex: '/Staff',
        name: getRouteName(MODULE_NAME, 'Home'),
        slots: [SLOT_KEY.SLOT_ADDITION_MENU],
        image: PreviewDListlImg,
    },
]

export default routes;